import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ProjectSelectionPage from './ProjectSelectionPage';
import { apiEndpoints, getApiBaseUrl } from '../utils/api';
import { useAuthenticatedApi } from '../hooks/useAuthenticatedApi';

const baseUrl = getApiBaseUrl();

function KolegaCode() {
    const authenticatedApi = useAuthenticatedApi();
    const [isProjectSelected, setIsProjectSelected] = useState(false);
    const [projectPath, setProjectPath] = useState('');
    const [port, setPort] = useState('8000');
    const navigate = useNavigate();
    const location = useLocation();
    const [iframeUrl, setIframeUrl] = useState(`${baseUrl}:${port}`);

    useEffect(() => {
        const fetchWorkspacePort = async () => {
            try {
                const workspaceId = localStorage.getItem('workspaceId');
                if (workspaceId) {
                    const workspaceData = await authenticatedApi.get(apiEndpoints.workspace(workspaceId));
                    if (workspaceData.port) {
                        const workspacePort = workspaceData.port.toString();
                        setPort(workspacePort);
                        setIframeUrl(`${baseUrl}:${workspacePort}`);
                    }
                }
            } catch (error) {
                console.error('Failed to fetch workspace port:', error);
            }
        };

        fetchWorkspacePort();

        // Reset state when navigating to project selection
        if (location.pathname === '/select-project') {
            setIsProjectSelected(false);
            setProjectPath('');
        }
    }, [location]);

    const handleProjectSelect = async (path, selectedPort) => {
        setProjectPath(path);
        if (selectedPort) {
            setPort(selectedPort);
            setIframeUrl(`${baseUrl}:${selectedPort}`);
        } else {
            // Ensure port state is updated even if not passed
            setIframeUrl(`${baseUrl}:${port}`);
        }
        setIsProjectSelected(true);
        // Navigation now handled inside ProjectSelectionPage
    };

    return (
        <div className="w-full h-full overflow-hidden bg-ui-background-primary">
            <ProjectSelectionPage onProjectSelect={handleProjectSelect} />
        </div>
    );
}

export default KolegaCode;